import { Breakpoint, useMediaQuery as MuiuseMediaQuery } from '@mui/material';
import { Theme } from 'theme';

export const useMediaQuery = {
	up: (size: Breakpoint) =>
		MuiuseMediaQuery((theme: Theme) => theme.breakpoints.up(size)),
	down: (size: Breakpoint) =>
		MuiuseMediaQuery((theme: Theme) => theme.breakpoints.down(size)),
};
